export default "__VITE_ASSET__74628439__"